import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { RouterStateUrl } from './state/router.reducer';
import { getRouterParams, getRouterQueryParams, getRouterSegments, getRouterUrl } from './state/router.selectors';
import { NavigationExtras } from '@angular/router';
import * as RouterActions from './state/router.actions';

@Injectable()
export class RouterFacade {
  routerUrl$ = this.store.pipe(select(getRouterUrl));
  routerParams$ = this.store.pipe(select(getRouterParams));
  routerQueryParams$ = this.store.pipe(select(getRouterQueryParams));
  routerSegments$ = this.store.pipe(select(getRouterSegments));

  constructor(private store: Store<RouterStateUrl>) {}

  go(path: any[], query?: object, extras?: NavigationExtras) {
    this.store.dispatch(RouterActions.Go({ path, query, extras }));
  }

  back() {
    this.store.dispatch(RouterActions.Back());
  }

  forward() {
    this.store.dispatch(RouterActions.Forward());
  }
}
